import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Text = styled.p`
  text-align: justify;
  padding: ${({ theme }) => theme.spacing.x5};
  font-size: ${({ theme }) => theme.fs.xs};
  line-height: ${({ theme }) => theme.spacing.x4};
  white-space: pre;
`;
export const ffpInput = styled.div`
  width: 100% !important;
  margin-right: 1rem !important;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    margin-right: 0 !important;
  }
`;

export const ButtonWrapperSend = styled.div`
  width: 100%;
  margin-top: 1rem !important;
`;

export const SidebarIconAndName = styled.div<{ $active?: any }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
  background-color: ${({ $active }) => ($active === 'purchased' ? ' #86efac' : '#fda4af')};
  padding: 10px;
  width: 100%;
  border-radius: ${({ theme }) => theme.rounded.x4};
`;
export const SidebarListItemSpan = styled.span<{ $active?: any }>`
  margin-inline-start: ${({ theme }) => theme.spacing.x4};

  color: ${({ theme, $active }) => ($active === 'purchased' ? theme.palette.success : theme.palette.warn)};
`;
export const SidebarListItemSvg = styled.div<{ $active?: any }>`
  color: ${({ theme, $active }) => ($active === 'purchased' ? theme.palette.success : theme.palette.warn)};
  font-size: ${({ theme }) => `${theme.fs.xxxl}`};
`;
